import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs } from '@/components/shell';
import { Icon, LinkButton, PageHeader } from '@/components/ui';
import { paths } from '@/routes/paths';

import { ApplicationsPanel } from './ApplicationsPage';
// For you moved to its own page: AI features -> Recommendations.
// import { RecommendationsPanel } from './RecommendationsPage';
import { SavedInternshipsPanel } from './SavedInternshipsPage';

/**
 * Every internship the student has a reason to come back to, on one page:
 * the ones they applied to and the ones they bookmarked. The ones we suggest
 * ("For you") live on their own Recommendations page.
 *
 * Each tab has its own URL, so a link, a notification or the browser's back
 * button lands on the right one, and the single sidebar entry stays lit on
 * both.
 */
const TABS = [
  // {
  //   key: paths.student.recommendations,
  //   label: 'For you',
  //   icon: 'sparkles',
  //   panel: RecommendationsPanel,
  // },
  {
    key: paths.student.applications,
    label: 'Applied',
    icon: 'clipboard',
    panel: ApplicationsPanel,
  },
  { key: paths.student.saved, label: 'Saved', icon: 'bookmark', panel: SavedInternshipsPanel },
];

export function MyInternshipsPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = TABS.find((tab) => tab.key === pathname) ?? TABS[0];
  const Panel = active.panel;

  return (
    // On a phone or tablet held upright the open tab's card runs to the
    // bottom of the screen.
    <div className="flex flex-col portrait:flex-1">
      <PageHeader
        title="My internships"
        description="Everything you applied to, and roles you saved."
        action={
          <LinkButton to={paths.internships} variant="tintBrand">
            <Icon name="search" size={16} />
            Find internships
          </LinkButton>
        }
      />
      <Tabs
        label="My internships"
        tabs={TABS.map(({ key, label, icon }) => ({ key, label, icon }))}
        value={active.key}
        onChange={(key) => navigate(key)}
      />
      <div className="mt-4 flex flex-1 flex-col">
        <Panel />
      </div>
    </div>
  );
}
